import { SystemStyleObject } from "@mui/system";
import { Theme } from "@mui/material";

export type DatePickerVariant = "filled" | "outlined";

export const datePickerVariantSx: Record<
  DatePickerVariant,
  SystemStyleObject<Theme>
> = {
  filled: {
    "& .MuiInputBase-root, & .MuiPickersInputBase-root": {
      backgroundColor: "background.input",
    },
    "& .MuiPickersSectionList-root": {
      color: "text.primary",
    },
    "& .MuiInputAdornment-root svg": {
      color: "text.secondary",
    },
    "& label, & .MuiInputLabel-root": {
      fontSize: "0.8125rem",
      "& svg": { fontSize: "0.938rem" },
      "& .MuiTypography-root": {
        fontSize: "inherit",
        fontWeight: "inherit",
        display: "inline-flex",
      },
    },
    "& label:not(.Mui-focused), & .MuiInputLabel-root:not(.Mui-focused)": {
      color: "text.secondary",
    },
    "& input, & .MuiPickersSectionList-root": {
      fontSize: "0.875rem",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink, & .MuiPickersInputLabel-outlined.MuiPickersInputLabel-shrink":
      {
        transform: "translate(0px, -20px)",
        fontWeight: 700,
      },
    "& .MuiInputBase-input:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px var(--mui-palette-background-input) inset",
    },
    "&.MuiFormControl-root, &.MuiPickersTextField-root": {
      width: "100%",
    },
  },
  outlined: {
    "& .MuiPickersSectionList-root": {
      color: "text.primary",
    },
    "& .MuiInputAdornment-root svg": {
      color: "text.secondary",
    },
    "& label, & .MuiInputLabel-root": {
      "& svg": { fontSize: "0.938rem" },
      "& .MuiTypography-root": {
        fontSize: "inherit",
        fontWeight: "inherit",
        display: "inline-flex",
      },
    },
    "& label:not(.Mui-focused), & .MuiInputLabel-root:not(.Mui-focused)": {
      color: "text.secondary",
    },
    "& input, & .MuiPickersSectionList-root": {
      fontSize: "0.875rem",
    },
    "& .MuiInputBase-input:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px var(--mui-palette-background-input) inset",
    },
    "&.MuiFormControl-root, &.MuiPickersTextField-root": {
      width: "100%",
    },
  },
};

export const datePickerDenseSx: SystemStyleObject<Theme> = {
  "& .MuiInputLabel-outlined.MuiInputLabel-shrink, & .MuiPickersInputLabel-outlined.MuiPickersInputLabel-shrink":
    {
      transform: "translate(14px, -9px) scale(0.75)",
      fontWeight: "normal",
      fontSize: "1rem",
      "& .MuiTypography-root": {
        fontSize: "inherit",
        fontWeight: "inherit",
        display: "inline-flex",
      },
    },
};
